import SponsoredInsuranceContainer from './SponsoredInsuranceContainer';

export default SponsoredInsuranceContainer;
